<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" :style="{ zIndex: device === 'mobile' ? 1000 : 1 }" />
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <!-- <img class="ml100 mr80 w70" src="../assets/img/logo1.png" alt="" /> -->
        <!-- <div class="flex1"> -->
        <navbar @close="handleClose" />
        <tags-view v-if="needTagsView" ref="tags" />
        <!-- </div> -->
      </div>
      <app-main />
      <!-- <right-panel v-if="showSettings">
        <settings />
      </right-panel> -->
      <Notice />
      <FaceTips v-if="system.needFace === 1" />
    </div>
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar, Notice, TagsView, FaceTips } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    Sidebar,
    Notice,
    TagsView,
    FaceTips
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    },
    system() {
      const data = localStorage.getItem("agentOemDetail");
      return data ? JSON.parse(data) : {};
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
    handleClose() {
      this.$refs.sidebar.collapse();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  min-width: 1200px;
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #f5f5f5;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - 210px);
  transition: width 0.28s;
  // background: #F6F9FA;
  // border-left: 1px solid #f3f3f4;
  // box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04)
}

.hideSidebar .fixed-header {
  width: calc(100% - 100px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
